import { useEffect, useMemo, useState } from "react";
import { withNamespaces } from "react-i18next";
import TableFilter from "src/components/TableFilter";
import {
    MEASURE_TYPE_OPTIONS,
    USAGE_STATUS_OPTIONS,
} from "../../helpers/measureList";

const FilteringComponent = ({ t, onChange }) => {
    const [tableFilters, setTableFilters] = useState({
        usageStatus: null,
        measureType: null,
        search: undefined,
    });

    const usageStatuses = useMemo(() => {
        return USAGE_STATUS_OPTIONS.map((option) => ({
            id: option.value,
            title: t(option.labelKey),
        }));
    }, [t]);

    const measureTypes = useMemo(() => {
        return MEASURE_TYPE_OPTIONS.map((option) => ({
            id: option.value,
            title: t(option.labelKey),
        }));
    }, [t]);

    const tableFilterTabs = useMemo(() => {
        return [
            {
                type: "radio_list",
                name: "usageStatus",
                title: "Used by your organization",
                icon: <i className="ri-checkbox-circle-line" />,
                isLoading: false,
                defaultValue: tableFilters?.usageStatus,
                data: usageStatuses,
                searchInListOption: {
                    enabled: false,
                    remote: false,
                },
                formatter: (item) => item.title,
            },
            {
                type: "radio_list",
                name: "measureType",
                title: "Type",
                icon: <i className="ri-list-check" />,
                isLoading: false,
                defaultValue: tableFilters?.measureType,
                data: measureTypes,
                searchInListOption: {
                    enabled: false,
                    remote: false,
                },
                formatter: (item) => item.title,
            },
            {
                type: "search_textbox",
                name: "search",
                title: "Search measures",
                icon: <i className="ri-search-line" />,
                defaultValue: tableFilters?.search,
                options: {
                    placeholder: "Search measures",
                    typingDelay: 750,
                },
                displayIndependently: true,
                onFilterChange: (value) => {
                    setTableFilters((currentState) => ({
                        ...currentState,
                        search: value,
                    }));
                },
            },
        ];
    }, [tableFilters, usageStatuses, measureTypes]);

    const onTableFilterOkButtonClicked = (filters, independentTabsData) => {
        if (filters) {
            const result = {};

            if ("usageStatus" in filters) {
                result.usageStatus = filters.usageStatus !== "all"
                    ? filters.usageStatus
                    : undefined;
            }

            if ("measureType" in filters) {
                result.measureType = filters.measureType !== "all"
                    ? filters.measureType
                    : undefined;
            }

            setTableFilters({
                ...tableFilters,
                ...result,
            });
        } else {
            setTableFilters({
                search: independentTabsData?.search || undefined,
                usageStatus: null,
                measureType: null,
            });
        }
    };

    useEffect(() => {
        onChange && onChange(tableFilters);
    }, [tableFilters, onChange]);

    return (
        <TableFilter
            className=""
            defaultActiveTab="usageStatus"
            tabs={tableFilterTabs}
            onOkButtonClicked={onTableFilterOkButtonClicked}
        />
    );
};

export default withNamespaces()(FilteringComponent);
